import {createDivIn, createParagraphIn, setElementInnerHTML} from '../ui_utils/DomUtils.ts'
import {ViewPopup} from './ViewPopup.ts'
import {ViewPopupLogin} from './ui_popup_membership_incentive/ViewPopupLogin.ts'

export class ViewPopupEndgameSignup extends ViewPopup {
    constructor(completedGameCount: number) {
        super({key: 'strings:game.endGame.signupPopup.title'}, {key: 'strings:colonistCommon.utils.emptyString'}, () => undefined, () => undefined, true)

        setElementInnerHTML(this.body, {key: 'strings:colonistCommon.utils.emptyString'})

        const signupPopupWrapper = createDivIn(this.body, 'popup-signup-wrapper', '')

        createParagraphIn(signupPopupWrapper, {key: 'strings:game.endGame.signupPopup.description', options: {playedGameCount: completedGameCount}}, '')

        const loginWrapper = createDivIn(signupPopupWrapper, 'popup-login-wrapper', '')
        ViewPopupLogin.createLoginProviderButtons(loginWrapper)
        ViewPopupLogin.createContinueAsGuestButton(loginWrapper, this)

        this.removeFooter()
        this.show()
    }
}
